module.exports = __webpack_public_path__ + "img/biandong.443c48cc.png";